import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, Fade } from '@mui/material';
import { DesktopNotificationDto } from '../../models/notifications/desktopNotificationDto';

interface DesktopNotificationsModalProps {
  open: boolean;
  notifications: DesktopNotificationDto[];
  onClose: () => void;
  onNotificationRead: () => void;
}

export const DesktopNotificationsModal: React.FC<DesktopNotificationsModalProps> = ({
  open,
  notifications,
  onClose,
  onNotificationRead,
}) => {
  const handleAction = () => {
    if (notifications.length === 0) {
      onClose();
    } else {
      onNotificationRead();
    }
  };

  // Используем key для принудительного пересоздания Dialog при смене уведомления
  const currentNotificationId = notifications.length > 0 ? notifications[0].id : null;

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 300 }}
      key={currentNotificationId}
    >
      <DialogTitle>Уведомления</DialogTitle>
      <DialogContent>
        {notifications.length > 0 ? (
          <Typography whiteSpace="pre-line">
            {notifications[0].text}
          </Typography>
        ) : (
          <Typography>Новостей больше нет</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAction}>
          {notifications.length === 0 ? 'Закрыть' : 'Прочитано'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

